import React from 'react';
import { RouteFormatter } from '../routes';

/**
 * Splits an array into `col` columns, distributing items as evenly as possible.
 * Uses ceil(remaining / remaining-cols) each step so larger chunks come first.
 *
 * @param {any[]} items - Array of items to split into columns
 * @param {number} col - Number of columns to split into (default: 5)
 * @returns {any[][]} A 2D array where each inner array is one column's items
 */
export const toColumns = (items, col = 5) => {
    const result = [];
    let start = 0;
    let remains = items.length;

    for (let i = 0; i < col; i++) {
        const size = Math.ceil(remains / (col - i));
        result.push(items.slice(start, start + size));
        start += size;
        remains -= size;
    }

    return result;
};

export const cityLink = (cityName, cityUrl, i) => {
    const href = RouteFormatter.listings({ first: cityUrl });

    return (
        <a key={i} href={href}>
            <h3 className="snif-p snif-regular mb-1">{cityName}</h3>
        </a>
    );
};

export const stateLink = (stateName, stateUrl, j) => {
    const href = RouteFormatter.listings({ first: stateUrl });

    return (
        <a key={j} href={href}>
            <h3 className="snif-p snif-regular mb-1">{stateName}</h3>
        </a>
    );
};
